export function FlagFR({ className = 'h-5 w-5 rounded-sm' }: Readonly<{ className?: string }>) {
  return (
    <svg viewBox="0 0 3 2" className={className} aria-hidden>
      <rect width="1" height="2" x="0" y="0" fill="#0055A4" />
      <rect width="1" height="2" x="1" y="0" fill="#FFFFFF" />
      <rect width="1" height="2" x="2" y="0" fill="#EF4135" />
    </svg>
  );
}

export function FlagGB({ className = 'h-5 w-5 rounded-sm' }: Readonly<{ className?: string }>) {
  return (
    <svg viewBox="0 0 60 30" className={className} aria-hidden>
      <clipPath id="u">
        <path d="M0,0 v30 h60 v-30 z" />
      </clipPath>
      <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
      <path d="M0,0 60,30 M60,0 0,30" stroke="#fff" strokeWidth="6" />
      <path d="M0,0 60,30 M60,0 0,30" stroke="#C8102E" strokeWidth="4" clipPath="url(#u)" />
      <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
      <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
    </svg>
  );
}

export function FlagES({ className = 'h-5 w-5 rounded-sm' }: Readonly<{ className?: string }>) {
  return (
    <svg viewBox="0 0 3 2" className={className} aria-hidden>
      <rect width="3" height="2" fill="#AA151B" />
      <rect y="0.5" width="3" height="1" fill="#F1BF00" />
    </svg>
  );
}

export function FlagBR({ className = 'h-5 w-5 rounded-sm' }: Readonly<{ className?: string }>) {
  return (
    <svg viewBox="0 0 720 504" className={className} aria-hidden>
      <rect width="720" height="504" fill="#009C3B" />
      <path d="M360 43 677 252 360 461 43 252Z" fill="#FFDF00" />
      <circle cx="360" cy="252" r="105" fill="#002776" />
    </svg>
  );
}
